import { useMemo, useState } from 'react';
import * as React from 'react';
import { Layout } from 'antd';
import { Select } from '@/components/atoms';
import { useLocation } from 'react-router-dom';
import { SiderProps } from 'antd/lib/layout';

import { useSelector } from 'react-redux';
import { RootState } from '@/rootReducer';
import AdminMenu from '@/components/molecules/menu/AdminMenu';
import ManageMenu from '@/components/molecules/menu/ManageMenu';
import TaxMenu from '@/components/molecules/menu/TaxMenu';
import { PATH_ADMIN, PATH_MANAGE, PATH_SERVICE, PATH_TAX } from '@/constants/constant';

const navigatorOptions: SideNavigatorOption[] = [
  {
    label: '스마트 민원',
    value: '스마트 민원',
    paths: [PATH_TAX, PATH_SERVICE],
    condition: () => true,
    menu: (path) => <TaxMenu path={path} />,
  },
  {
    label: '비즈센터 관리',
    value: '비즈센터 관리',
    paths: [PATH_MANAGE],
    condition: () => true,
    menu: (path) => <ManageMenu path={path} />,
  },
  {
    label: '관리자 메뉴',
    value: '관리자 메뉴',
    paths: [PATH_ADMIN],
    condition: (user) => user.role.includes('ADMIN'),
    menu: (path) => <AdminMenu path={path} />,
  },
];

type SideNavigatorOption = {
  label: string;
  value: string;
  paths: string[];
  condition: (user: any, solutions: any[]) => boolean;
  menu: (path: string) => React.ReactNode;
};

type SideNavigatorProps = {
  // TODO
};

const SideNavigator = (props: SideNavigatorProps & SiderProps) => {
  const { user } = useSelector((state: RootState) => state.account);
  const { solutionIds } = useSelector((state: RootState) => state.company);
  const { pathname } = useLocation();

  const options = useMemo(() => {
    return navigatorOptions.filter((each) => each.condition(user, solutionIds));
  }, [user, solutionIds]);

  const [option, setOption] = useState(options.first((each) => each.paths.filter((path) => pathname.includes(path)).length > 0)?.value);

  return (
    <Layout.Sider {...props} className="side-navigator">
      <div style={{ padding: '8px 24px' }}>
        <Select
          defaultValue={option}
          value={option}
          onChange={(value) => setOption(value)}
          options={options.filter((each) => each.condition(user, solutionIds))}
        />
      </div>
      {options.first((each) => each.value === option)?.menu(pathname)}
    </Layout.Sider>
  );
};

SideNavigator.defaultProps = {
  // TODO
};

export default SideNavigator;
